import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/format H1.svg` */
export const FormatH1Icon = createTripletGlyphIcon('FormatH1Icon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.80115 1.6322C9.13238 1.63226 9.4006 1.90061 9.40076 2.23181V13.7699C9.40076 14.1012 9.13247 14.3704 8.80115 14.3705C8.46987 14.3704 8.20056 14.1012 8.20056 13.7699V8.60095H3.31091V13.7699C3.31091 14.1013 3.04267 14.3705 2.7113 14.3705C2.38003 14.3704 2.11169 14.1012 2.11169 13.7699V2.23181C2.11185 1.90064 2.38012 1.63231 2.7113 1.6322C3.04258 1.6322 3.31076 1.90057 3.31091 2.23181V7.40076H8.20056V2.23181C8.20072 1.90064 8.46996 1.63231 8.80115 1.6322Z"
        fill="currentColor"
      />
      <path
        d="M12.8646 5.97498C13.0361 5.80355 13.2939 5.7515 13.5179 5.84412C13.742 5.93703 13.889 6.15619 13.889 6.3988V13.7709C13.8889 14.102 13.6196 14.3704 13.2885 14.3705C12.9573 14.3704 12.689 14.102 12.6888 13.7709V7.84705L11.7894 8.74646C11.5553 8.98023 11.176 8.98015 10.9418 8.74646C10.7075 8.51215 10.7075 8.13214 10.9418 7.89783L12.8646 5.97498Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.90149 1.91187C10.2327 1.91208 10.5021 2.18024 10.5021 2.51147V15.4919C10.5019 15.823 10.2326 16.0923 9.90149 16.0925C9.57041 16.0923 9.30208 15.823 9.30188 15.4919V9.60229H3.65051V15.4919C3.65032 15.823 3.38197 16.0923 3.0509 16.0925C2.71965 16.0925 2.45149 15.8231 2.45129 15.4919V2.51147C2.45129 2.1801 2.71953 1.91187 3.0509 1.91187C3.38209 1.91208 3.65051 2.18024 3.65051 2.51147V8.4021H9.30188V2.51147C9.30188 2.18023 9.57029 1.91207 9.90149 1.91187Z"
        fill="currentColor"
      />
      <path
        d="M14.5255 6.77515C14.6971 6.60355 14.9556 6.55142 15.1798 6.64429C15.4037 6.73729 15.5499 6.95651 15.5499 7.19897V15.4919C15.5497 15.8231 15.2805 16.0924 14.9493 16.0925C14.6183 16.0923 14.3499 15.823 14.3497 15.4919V8.64722L13.2101 9.78687C12.9759 10.0206 12.5967 10.0205 12.3624 9.78687C12.1281 9.55258 12.1282 9.17255 12.3624 8.93823L14.5255 6.77515Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2017 2.54785C13.6433 2.54793 14.0012 2.90609 14.0015 3.34766V20.6553C14.0015 21.0971 13.6434 21.455 13.2017 21.4551C12.76 21.4549 12.4019 21.097 12.4019 20.6553V12.8018H4.8667V20.6553C4.8667 21.0971 4.50872 21.4551 4.06689 21.4551C3.62526 21.4549 3.26709 21.097 3.26709 20.6553V3.34766C3.26733 2.90617 3.62541 2.54807 4.06689 2.54785C4.50857 2.54785 4.86646 2.90604 4.8667 3.34766V11.2012H12.4019V3.34766C12.4021 2.90617 12.7602 2.54807 13.2017 2.54785Z"
        fill="currentColor"
      />
      <path
        d="M19.3677 9.03223C19.5964 8.80386 19.9401 8.73484 20.2388 8.8584C20.5375 8.98218 20.7327 9.27429 20.7329 9.59766V20.6553C20.7329 21.097 20.3747 21.4549 19.9331 21.4551C19.4913 21.4551 19.1333 21.0971 19.1333 20.6553V11.5283L17.6138 13.0479C17.3014 13.3602 16.7953 13.3602 16.4829 13.0479C16.1706 12.7354 16.1706 12.2294 16.4829 11.917L19.3677 9.03223Z"
        fill="currentColor"
      />
    </svg>
  ),
});
